/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BabylonAddressSummaryInfo } from './BabylonAddressSummaryInfo';

export type BabylonContractCodeDetailInfo = {
    CODEID: string;
    CHCKSUM: string;
    CRTADDR: BabylonAddressSummaryInfo;
    PRMSSN: BabylonContractCodeDetailInfo.PRMSSN;
};

export namespace BabylonContractCodeDetailInfo {

    export enum PRMSSN {
        UNSPECIFIED = 'UNSPECIFIED',
        NOBODY = 'NOBODY',
        EVERYBODY = 'EVERYBODY',
        ANY_OF_ADDRESSES = 'ANY_OF_ADDRESSES',
    }


}

